import { useState, useEffect } from 'react';
import { promotionsService } from '../../../../services/promotionService';

export const usePromotionsData = (effectiveTenantId, isSuperAdmin) => {
    const [promotions, setPromotions] = useState([]);
    const [menuData, setMenuData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        promotionsService.fetchMenu(effectiveTenantId)
            .then(data => {
                if (data) setMenuData(data);
            });

        const unsubscribe = promotionsService.subscribeToPromotions(
            effectiveTenantId,
            isSuperAdmin,
            (data) => {
                setPromotions(data);
                setLoading(false);
            }
        );

        return () => unsubscribe();
    }, [effectiveTenantId, isSuperAdmin]);

    return { promotions, menuData, loading };
};